module.exports = __webpack_public_path__ + "static/img/5.51ebc1a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/3/eng/5.png
// module id = faEe
// module chunks = 0